<template>
    <section class="balance-layout" aria-label="残高">
        <article class="balance-section balance-section--stacked">
            <div class="balance-section__header">
                <span>{{ $t('userWallet.balance.title') }}</span>
            </div>
            <div class="balance-section__body">
                <div v-if="loading" class="loading-row">{{ $t('userWallet.loading') }}</div>

                <div v-else-if="error" class="danger-note m-3">{{ $t('userWallet.errors.loadFailed') }}</div>

                <div v-else-if="walletInfo" class="stacked-balance">
                    <div
                        v-for="asset in assets"
                        :key="asset.key"
                        class="stacked-row"
                    >
                        <span class="asset-logo">
                            <img :src="asset.icon" alt="" width="30" height="30">
                        </span>

                        <div class="stacked-row__name">
                            <h3>{{ asset.name }}</h3>
                            <p>{{ asset.subtitle }}</p>
                        </div>

                        <div class="stacked-row__balance">
                            <p class="stacked-row__amount">
                                {{ formatAmount(walletInfo.balances[asset.availableBalanceKey]) }}
                                {{ asset.symbol }}
                            </p>
                        </div>

                        <div class="stacked-row__actions">
                            <!-- Phase 2 -->
                            <button
                                v-if="asset.actions.send"
                                class="pill-button"
                                type="button"
                                @click="$emit('send', asset.key)"
                            >
                                <span>{{ $t('userWallet.send.button') }}</span>
                                <img src="/assets/images/wallets/send.svg" alt="" width="21" height="21">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <!-- 受取 -->
        <div v-if="walletInfo" class="stacked-receive">
            <button class="pill-button" type="button" @click="$emit('receive')">
                <span>{{ $t('userWallet.receive.button') }}</span>
                <img src="/assets/images/wallets/receive.svg" alt="" width="21" height="21">
            </button>
            <button
                class="pill-button pill-button--staking"
                type="button"
                @click="$emit('stake')"
            >
                <span>{{ $t('userWallet.stake.button') }}</span>
            </button>
        </div>
    </section>
</template>

<script>
    import walletFormatMixin from '../../../utils/walletFormatMixin.js';
    import {CURRENCIES, enabledCurrencies} from '../constants/currencies.js';

    export default {
        name: 'WalletBalanceSection',

        mixins: [walletFormatMixin],

        props: {
            loading: {type: Boolean, default: false},
            error: {type: Boolean, default: false},
            walletInfo: {type: Object, default: null},
        },

        computed: {
            assets() {
                return enabledCurrencies().map((symbol) => {
                    const currency = CURRENCIES[symbol];
                    return {
                        key: currency.balanceKey,
                        availableBalanceKey: currency.availableBalanceKey,
                        name: currency.name,
                        subtitle: currency.subtitle,
                        symbol: currency.symbol,
                        icon: currency.icon,
                        actions: currency.actions,
                    };
                });
            },

            updatedAt() {
                return this.walletInfo && this.walletInfo.balances.updated_at
                    ? this.walletInfo.balances.updated_at
                    : null;
            },
        },
    };
</script>
